import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { MOBILE_NAMESPACE } from '@/i18n';
import '@/Pages/Mobile/MobilePage.sass';

export function MobileValidationFooter(): JSX.Element {
  const { t } = useTranslation(MOBILE_NAMESPACE);

  return (
    <Box
      component="footer"
      className="mobile-validation-footer"
      data-testid="mobile-validation-footer"
    >
      <Box
        className="mobile-validation-footer__security"
        data-testid="mobile-validation-security-message"
      >
        <LockOutlinedIcon aria-hidden fontSize="small" />
        <Typography component="span" variant="caption">
          {t('footer.security')}
        </Typography>
      </Box>
    </Box>
  );
}
